import React from 'react';
import ShortDescriptionContent from './ShortDescriptionContent';
import {
  SketchCircleFilled,
  CodepenCircleOutlined,
  FireFilled,
  CodeSandboxCircleFilled,
} from '@ant-design/icons';
import Container from '../wrapper/Container';
import LZRow from '../grid/LZRow';
import {Col} from 'antd';

const style = {
  iconStyle: {
    fontSize: 40,
  },
  containerStyle: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 20,
    marginBottom: 60,
  },
};

export default function ShortDescription() {
  return (
    <Container style={style.containerStyle}>
      <LZRow>
        <Col lg={6} xs="24">
          <ShortDescriptionContent
            title="Creative Solution"
            content="Lorem Ipsum simply dummy text of the printing typesetting industry simply dummy text typesetting."
            Icon={<CodeSandboxCircleFilled style={style.iconStyle} />}
          />
        </Col>
        <Col lg={6} xs="24">
          <ShortDescriptionContent
            title="Diverse Approach"
            content="Lorem Ipsum simply dummy text of the printing typesetting industry simply dummy text typesetting."
            Icon={<FireFilled style={style.iconStyle} />}
          />
        </Col>
        <Col lg={6} xs="24">
          <ShortDescriptionContent
            title="Detailed Reports"
            content="Lorem Ipsum simply dummy text of the printing typesetting industry simply dummy text typesetting."
            Icon={<CodepenCircleOutlined style={style.iconStyle} />}
          />
        </Col>
        <Col lg={6} xs="24">
          <ShortDescriptionContent
            title="Professional Team"
            content="Lorem Ipsum simply dummy text of the printing typesetting industry simply dummy text typesetting."
            Icon={<SketchCircleFilled style={style.iconStyle} />}
          />
        </Col>
      </LZRow>
    </Container>
  );
}
